const ArticleCardSkeleton = () => (
  <div className="flex flex-col rounded-[14px] border-2 border-[#d0e2df] bg-white p-[18px]">
    <div className="mb-2 h-[250px] w-full animate-pulse rounded-sh-16 bg-gray-200" />
    <div className="flex flex-col gap-2">
      <div className="h-5 w-3/4 animate-pulse rounded bg-gray-200" />
      <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
      <div className="h-4 w-2/3 animate-pulse rounded bg-gray-200" />
      <div className="flex items-center gap-4 pt-4">
        <div className="h-10 w-28 animate-pulse rounded-lg bg-gray-200" />
        <div className="h-5 w-24 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
  </div>
);

export const ArticlesAndPodcastsSectionSkeleton = () => (
  <div className="mb-sh-30 bg-light-green">
    <div className="mb-sh-15 h-8 w-56 animate-pulse rounded bg-gray-200" />
    <div className="mb-sh-30 h-5 w-80 animate-pulse rounded bg-gray-200" />
    <div className="grid grid-cols-1 gap-sh-30 md:grid-cols-2">
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
    </div>
  </div>
);
